import axios from 'axios'

/**
 * Areas API
 * @returns 
 */
export const fetchAreas = async (city = null) => {
    axios.defaults.withCredentials = true;
    
    let requestUrl
    requestUrl = `${process.env.REACT_APP_API}/areas/index.json` 
            
    try {
        const res = await axios.get(requestUrl);
        return res.data;

    } catch (e) {
      if (axios.isAxiosError(e) && e.response &&  e.response.status === 400) {
        console.log('400 Error!!');
        console.log(e.message); //Axiosの例外オブジェクトとして扱える
      }else if(axios.isAxiosError(e) && e.response &&  e.response.status === 500){
        console.log('500 Error!!');
        console.log(e.message); //Axiosの例外オブジェクトとして扱える
      }
    }

};

export const fetchCities = async (areaId:number) => {
  axios.defaults.withCredentials = true;
  let requestUrl

  areaId === 0 ? requestUrl = `${process.env.REACT_APP_API}/cities/index.json` 
          :  requestUrl = `${process.env.REACT_APP_API}/cities/index.json?area=${areaId}`
          
  try {
      const res = await axios.get(requestUrl);

      return res.data;

  } catch (e) {
    if (axios.isAxiosError(e) && e.response &&  e.response.status === 400) {
      console.log('400 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }else if(axios.isAxiosError(e) && e.response &&  e.response.status === 500){
      console.log('500 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }
  }
  
};

export const fetchStores = async (query:string) => {
  axios.defaults.withCredentials = true;
  let requestUrl

  requestUrl = `${process.env.REACT_APP_API}/stores/index.json?${query}`
          
  try {
      const res = await axios.get(requestUrl);

      return res.data;

  } catch (e) {
    if (axios.isAxiosError(e) && e.response &&  e.response.status === 400) {
      console.log('400 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }else if(axios.isAxiosError(e) && e.response &&  e.response.status === 500){
      console.log('500 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }
  }
  
};

export const fetchCsrfToken = async() => {
  axios.defaults.withCredentials = true;

  try {
    const res = await axios.get(`${process.env.REACT_APP_API}/applicants/csrfToken.json`);
    
    axios.defaults.headers.common['X-CSRF-Token'] = res.data.csrfToken;

    return res.data;

  } catch (e) {
    if (axios.isAxiosError(e) && e.response &&  e.response.status === 400) {
      console.log('400 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }else if(axios.isAxiosError(e) && e.response &&  e.response.status === 500){
      console.log('500 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }
  }
}

export const fetchEntry =  async (formData:FormData) => {
  axios.defaults.withCredentials = true;

  try {
      const res = await axios.post(`${process.env.REACT_APP_API}/applicants/entry.json`,formData);
      return res.data;

  } catch (e) {
    if (axios.isAxiosError(e) && e.response &&  e.response.status === 400) {
      console.log('400 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }else if(axios.isAxiosError(e) && e.response &&  e.response.status === 500){
      console.log('500 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }
  }
}

export const fetchCompCheck =  async (id:string) => {
  axios.defaults.withCredentials = true;

  try {
      const res = await axios.post(`${process.env.REACT_APP_API}/applicants/comp.json`,{id: id});
      return res.data;

  } catch (e) {
    if (axios.isAxiosError(e) && e.response &&  e.response.status === 400) {
      console.log('400 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }else if(axios.isAxiosError(e) && e.response &&  e.response.status === 500){
      console.log('500 Error!!');
      console.log(e.message); //Axiosの例外オブジェクトとして扱える
    }
  }
}